module.exports = __webpack_public_path__ + "img/cat-outline.62752cd1.png";